module.exports = __webpack_public_path__ + "static/img/pdf.9cb7b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pdf.png
// module id = tYfS
// module chunks = 0